import _ from "lodash";
import React, { useEffect, useState } from "react";
import { Box, Button, Modal, TextField, InputLabel } from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import moment from "moment";
import ArrowForwardOutlinedIcon from "@mui/icons-material/ArrowForwardOutlined";
import IconCancel from "src/assets/images/icon_cancel.svg";
import { DispatchForm } from "./add";
import { Loader } from "src/components/loader";
import IconLeftArrow from "src/assets/images/icon_left_arrow.svg";
import IconError from "src/assets/images/icon_error.svg";
import { toast } from "react-toastify";
import toastMessages from "src/constant/toastMessages.json";
import * as yup from "yup";
import {
  getDispatchOrderByIdAction,
  editDispatchOrder,
  deleteDeliveryOrderRecord,
} from "src/thunks/dispatchOrder";
import { GetError, convertIsoToLocalDateTime, getFloatValue, tConvert } from "src/constant";
import { getAllNofificationForDashboard } from "src/thunks/dashboard";
import DeleteIcon from "@mui/icons-material/Delete";
import { useForm } from "react-hook-form";
import { yupResolver } from '@hookform/resolvers/yup';
import { Addremarks } from "src/thunks/goodsin";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  width: "77%",
  height: "100%",
  bgcolor: "background.paper",
  overflowY: "scroll",
};

const cancelModalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  // width: "50%",
  paddingBottom: "20px",
  bgcolor: "background.paper"
};

export const Details = () => {
  /** redux store useDispatch & useSelector ------------------------------ **/
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const { signoutModelOpenFlag } = useSelector((state) => state.auth);
  const lookupValues = useSelector((state) => state.lookup.data);
  const { goodsData, ...rest } = useSelector((state) => state.dispatch);

  /** hooks useState ----------------------------------------------------- **/
  const [open, setOpen] = React.useState(false);
  const [openCancelModel, _openCancelModel] = useState(false);
  const [deleteRecordModal, _deleteRecordModal] = useState(false);
  const [loader, setLoader] = useState(false);
  const [dispatchDetailsData, _dispatchDetailsData] = useState({});
  const [allDispatchItem, _allDispatchItem] = useState([]);
  const [isUpdateShow, setIsUpdateShow] = useState(false);
  const [vehicalData, setVehicalData] = useState([]);
  const [ActiveIndex, setActiveIndex] = useState(0);
  const [
    checkAllAvailableDataIsDispatched,
    setCheckAllAvailableDataIsDispatched,
  ] = useState(false);
  const [isFullScreen, setIsFullScreen] = useState(false);
  const [selectedImage, setSelectedImage] = useState(null);
  const [showRemark, setShowRemark] = useState(false);
  /** variable declarations ----------------------------------------------------- **/
  let { id } = useParams();
  let statusflag = "#0045D9";
  let getIndividualDispatchOrderDataMod = {
    ...rest.getIndividualDispatchOrderData,
  };
  if (typeof getIndividualDispatchOrderDataMod.statusId === "number") {
    getIndividualDispatchOrderDataMod.status = lookupValues?.find(
      (v) => v.id === getIndividualDispatchOrderDataMod.statusId
    )?.name;
  }
  if (typeof getIndividualDispatchOrderDataMod.typeId === "number") {
    getIndividualDispatchOrderDataMod.type = lookupValues?.find(
      (lv) => lv.id == getIndividualDispatchOrderDataMod.typeId
    )?.name;
  }
  const deliveryItems = getIndividualDispatchOrderDataMod?.deliveryItems || [];
  let ActiveData = vehicalData.length > 0 ? vehicalData[ActiveIndex] : {};
  let damageCount =
    _.filter(deliveryItems, (d) => d.conditionId === 24)?.length || 0;
  let unitsCount = _.sumBy(deliveryItems, (d) => d.quantity) || 0;
  let damageCountForDispatch =
    _.filter(ActiveData?.items || [], (d) => d.condition === "Damaged")
      ?.length || 0;
  let unitsCountForDispatch = _.sumBy(
    allDispatchItem,
    (d) => d.quantityDispatched
  );
  let internalSpaceCountForDispatch = getFloatValue(
    _.sumBy(
      _.filter(ActiveData.items, (d) => d.storage === 21) || [],
      (d1) => d1.spaceReleased
    )
  );
  let externalSpaceCountForDispatch = getFloatValue(
    _.sumBy(
      _.filter(ActiveData.items, (d) => d.storage === 22) || [],
      (d1) => d1.spaceReleased
    )
  );
  const uploadedPicture = _.filter(
    ActiveData.dispatchEvidences || [],
    (d) => d.typeId === 26
  );
  const uploadeddocument = _.filter(
    ActiveData.dispatchEvidences || [],
    (d) => d.typeId === 25
  );
  const projectManager =
    getIndividualDispatchOrderDataMod?.projectManager || {};
  const depotManager = getIndividualDispatchOrderDataMod?.depotManager || {};
  const address = getIndividualDispatchOrderDataMod?.address || {};
  const raisedBy = getIndividualDispatchOrderDataMod?.raisedBy || {};
  const approvedBy = getIndividualDispatchOrderDataMod?.approvedBy || {};

  const deliveryStatus = [
    { status: "RAISED", date: "13-MAR-23", time: "15:30", name: "Review" },
    { status: "ACCEPTED", date: "13-MAR-23", time: "15:30", name: "Pending" },
    { status: "LOADING", date: "13-MAR-23", time: "15:30", name: "Loading" },
    {
      status: "DEPARTURE",
      date: "13-MAR-23",
      time: "15:30",
      name: "InTransit",
    },
    { status: "DELIVERY", date: "13-MAR-23", time: "15:30", name: "Delivered" },
    {
      status: "CANCELLED",
      date: "13-MAR-23",
      time: "15:30",
      name: "Cancelled",
    },
    {
      status: "DEPARTURE",
      date: "13-MAR-23",
      time: "15:30",
      name: "Dispatched",
    },
  ];

  const collectionDeliveryStatus = [
    { status: "RAISED", date: "13-MAR-23", time: "15:30", name: "Review" },
    { status: "ACCEPTED", date: "13-MAR-23", time: "15:30", name: "Pending" },
    { status: "LOADING", date: "13-MAR-23", time: "15:30", name: "Loading" },
    {
      status: "DEPARTURE",
      date: "13-MAR-23",
      time: "15:30",
      name: "Dispatched",
    },
  ];

  const {
    register,
    handleSubmit,
    reset,
    formState: { errors },
    setValue,
  } = useForm({
    defaultValues: {
      comments: "",
    },
    resolver: yupResolver(
      yup.object().shape({
        comments: yup.string().required("Remarks is rquired"),
      })
    )
  })
  /** hooks useEffect----------------------------------------------------- **/
  useEffect(() => {
    getDispatchOrderInDataFunc();
  }, []);

  useEffect(() => {
    statusflag = "#0045D9";
  }, [getIndividualDispatchOrderDataMod]);

  useEffect(() => {
    let updated = { ...rest.getIndividualDispatchOrderData };
    if (updated.deliveryItems) {
      updated.deliveryItems = updated.deliveryItems.map((di) => {
        return {
          ...di,
          condition: lookupValues?.find((lv) => lv.id == di.conditionId)?.name,
        };
      });
      setAddedData(updated);
      _dispatchDetailsData(updated || {});
    }
  }, [rest.getIndividualDispatchOrderData]);

  /** handler functions--------------------------------------------------- **/
  const setAddedData = (Data) => {
    let dispatchItem = [];
    let VehicalData = _.map(Data?.dispatches, (d, key) => {
      if (d.status === "Pending" && !isUpdateShow) {
        setIsUpdateShow(true);
      }
      dispatchItem = [...dispatchItem, ...d.dispatchItems];
      let loadingDateTime = convertIsoToLocalDateTime(
        `${d?.loadingDateTime}.00Z`,
        "DD-MMM-YYYY, HH:mm"
      );
      return {
        ...d,
        tabName: `VEHICLE ${key + 1}`,
        // tabName: `VEHICLE`,
        vehicleRegistration: d?.vehicleRegistration || "",
        departureDate1: d?.departureDate || "",
        vehicleModel: d?.vehicleModel || "",
        driverName: d?.driverName || "",
        driverContact: d?.driverContact || "",
        transitTime: d.transitTime || "",
        receiverName: d.receiverName || "",
        receiverPosition: d.receiverPosition || "",
        receiverPhone: d.receiverPhone || "",
        departureDate: d?.loadingDateTime
          ? new Date(loadingDateTime)
          : new Date(),
        departureTime1: moment(
          new Date(loadingDateTime) || new Date()
        ).hour(),
        departureTime2: moment(
          new Date(loadingDateTime) || new Date()
        ).minute(),
        key: `dispatch${key + 1}`,
        items: [
          ...d.dispatchItems.map((di) => {
            return {
              ...di,
              condition: lookupValues?.find((lv) => lv.id === di.conditionId)
                ?.name,
            };
          }),
        ],
      };
    });
    setVehicalData([...VehicalData]);
    _allDispatchItem([...dispatchItem]);
  };

  const handleClose = () => setOpen(false);

  const finalDeliveryStatus = () => {
    if (getIndividualDispatchOrderDataMod?.typeValue == "ClientCollection") {
      return _.filter(
        deliveryStatus,
        (d) => !["Cancelled", "Delivered", "InTransit"].includes(d?.name)
      );
    } else if (getIndividualDispatchOrderDataMod?.statusValue == "Cancelled") {
      let filterReq = ["Loading", "InTransit", "Delivered", "Dispatched"];
      let checkAccept =
        _.find(
          getIndividualDispatchOrderDataMod?.deliveryOrderStatusEvents || [],
          (d) => d.statusValue == "Pending"
        ) || false;
      if (!checkAccept) {
        return _.filter(
          deliveryStatus,
          (d) => ![...filterReq, "Pending"].includes(d?.name)
        );
      }
      return _.filter(deliveryStatus, (d) => !filterReq.includes(d?.name));
    } else {
      return _.filter(
        deliveryStatus,
        (d) => !["Cancelled", "Dispatched"].includes(d?.name)
      );
    }
  };

  const getDispatchOrderInDataFunc = async () => {
    setLoader(true);
    try {
      let data = await dispatch(getDispatchOrderByIdAction({ id: id || "22" })).unwrap();
      setLoader(false);
      if (!data) {
        toast.error("This Record Not found.")
        navigate("/app/dispatchorders/list")
      }
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
      setLoader(false);
    }
  };

  const handleDeleteRecordClick = async () => {
    try {
      let result = await dispatch(
        deleteDeliveryOrderRecord({
          id: id,
          orderNo: getIndividualDispatchOrderDataMod?.orderNo || "",
          typeId: getIndividualDispatchOrderDataMod.typeId,
          typeName: getIndividualDispatchOrderDataMod?.typeValue,
          ProjectId: getIndividualDispatchOrderDataMod?.projectId,
        })
      ).unwrap();
      setTimeout(() => {
        dispatch(getAllNofificationForDashboard(1, 20));
      }, 2000);
      toast.success(toastMessages.deliveryOrderRemoved);
      _deleteRecordModal(!deleteRecordModal);
      navigate("/app/dispatchorders/list");
    } catch (error) {
      toast.error(
        GetError(error?.response?.data?.errors) ||
        error?.message ||
        "Something went wrong"
      );
    }
  };

  const handleCancelOrderClick = async () => {
    try {
      let newData = { ...getIndividualDispatchOrderDataMod };
      delete newData.status;
      let req = {
        ...newData,
        id: newData.id,
        projectId: newData?.projectId,
        clientId: newData?.clientId,
        depotId: newData?.depotId,
        orderNo: newData.orderNo,
        projectManagerId: newData?.projectManager?.id,
        dueDate: newData.dueDate,
        dueTime: newData.dueTime,
        ClientName: newData?.clientName,
        statusId: 12,
        deliveryItems: newData.deliveryItems,
        typeId: newData.typeId,
        typeName: newData.type,
        deliveryOrderRemarks: "",
      };

      let res = await dispatch(editDispatchOrder(req)).unwrap();
      await getDispatchOrderInDataFunc();
      if (res) {
        setTimeout(() => {
          dispatch(getAllNofificationForDashboard(1, 20));
        }, 2000);
        toast.success(toastMessages.dispatchOrderCancel);
        navigate("/app/dispatchorders");
      }
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }
  };

  const handleHoursAndMinutes = (data, type) => {
    let hours = 0;
    let minutes = 0;

    let convertedArray = _.map(data || [], (d) => {
      let temp = "00:00:00";
      if (type == "onSiteTime") {
        temp = d?.onSiteTime || "00:00:00";
      }
      let splitTemp = temp.split(":");
      hours = hours + parseInt(splitTemp[0]);
      minutes = minutes + parseInt(splitTemp[1]);
    });
    if (minutes > 59) {
      let newhours = minutes / 59;
      let splitNewhours = newhours.split(".");
      hours = hours + splitNewhours[0];
      minutes = splitNewhours[1];
    }
    return `${hours ? hours : "00"} : ${minutes ? minutes : "00"}`;
  };

  const openFullScreen = (image) => {
    setIsFullScreen(true);
    setSelectedImage(image);
  };

  const closeFullScreen = () => {
    setIsFullScreen(false);
    setSelectedImage(null);
  };



  const imgError = (image) => {
    image.onerror = "";
    image.src = "https://img.freepik.com/free-icon/user_318-563642.jpg";
    return true;
  }

  const handleCancelRemark = () => {
    setShowRemark(!showRemark);
    reset();
  };
  let remarks = getIndividualDispatchOrderDataMod.deliveryOrderRemarks;
  const remarksData = _.orderBy(remarks, ["timeStamp"], ["desc"]);
  let userDetails = JSON.parse(localStorage.getItem("userDetails"));

  const handleSubmitRemark = async (data) => {
    try {
      let newData = { ...getIndividualDispatchOrderDataMod };
      let req = {
        id: newData.id,
        apiModule: "DeliveryOrder",
        deliveryOrderRemarks: data?.comments,
        userDetails:
          userDetails?.firstName || "" + " " + userDetails?.lastName || "",
        DeliveryOrderType: getIndividualDispatchOrderDataMod?.typeValue,
        DeliveryOrderNo: newData?.orderNo,
        projectId: newData?.projectId,
      };
      let res = await dispatch(Addremarks(req)).unwrap();
      await getDispatchOrderInDataFunc();
      if (res) {
        setTimeout(() => {
          dispatch(getAllNofificationForDashboard(1, 20));
        }, 2000);
        setShowRemark(false);
        reset();
      }
      toast.success(toastMessages.dispatchOrderRemarks);
    } catch (error) {
      toast.error(GetError(error?.response?.data?.errors) || "something issue");
    }
  };


  if (loader) {
    return <Loader />;
  }
  return (
    <>
      <div className={`container-fluid mt-2 ${signoutModelOpenFlag == true ? "add-overlay-for-depot-dropdown" : ""
        }`}
      >
        <div className="row g-0">
          <div className="col-2 col-lg-1 d-flex justify-content-lg-center first-row-details-pm-goodsin-page pb-3" onClick={() => navigate(-1)}>
            <div className="d-flex justify-content-center align-items-center goodsin-back-icon-size">
              <img src={IconLeftArrow} alt="left arrow" />
            </div>
          </div>

          <div className="col-12 col-lg-9">
            <div className="goodsin-subdiv-style w-100">
              <div className="ms-2 me-2">
                <div className="row d-flex align-items-center first-row-in-goodsin-details">
                  <div className="col-md-5 details-ref-number-style">
                    {getIndividualDispatchOrderDataMod?.orderNo || ""}
                    <span className="ps-2 deliverytext-style text-uppercase">
                      {getIndividualDispatchOrderDataMod?.type == "Delivery"
                        ? "Delivery"
                        : "Collection"}
                    </span>
                  </div>
                  <div className="col-md-4 col-md-4 d-flex justify-content-end">
                    <span className="d-flex align-items-center goodsin-received-date-text-style">
                      DUE{" "}
                    </span>
                    <span className="details-top-date-text-style ps-2 text-uppercase">
                      {convertIsoToLocalDateTime(`${getIndividualDispatchOrderDataMod?.dueDate?.split("T")[0]}T${getIndividualDispatchOrderDataMod?.dueTime ? getIndividualDispatchOrderDataMod?.dueTime : "00:00:00"}.00Z`, "DD-MMM-YYYY HH:mm")}
                    </span>
                  </div>
                  <div className="col-md-3 d-flex justify-content-end">
                    <span className="d-flex align-items-center goodsin-received-date-text-style">
                      STATUS :{" "}
                    </span>
                    <span
                      className={`text-uppercase goodsin-details-status-color ps-2 ${getIndividualDispatchOrderDataMod.statusValue ==
                        "Review" ||
                        getIndividualDispatchOrderDataMod.statusValue == "Pending"
                        ? "add-dispatch-tbl-red-status-color"
                        : getIndividualDispatchOrderDataMod.statusValue ==
                          "Loading"
                          ? "add-dispatch-tbl-loading-status-color"
                          : getIndividualDispatchOrderDataMod.statusValue ==
                            "Delivered" ||
                            getIndividualDispatchOrderDataMod.statusValue ==
                            "Dispatched"
                            ? "add-dispatch-tbl-green-status-color"
                            : getIndividualDispatchOrderDataMod.statusValue ==
                              "InTransit"
                              ? "add-dispatch-tbl-blue-status-color"
                              : "add-dispatch-tbl-black-status-color"
                        }`}
                    >
                      {getIndividualDispatchOrderDataMod?.status || ""}
                    </span>
                  </div>
                </div>

                <div className="row pt-4 pb-2 add-border-inbetween-class">
                  {/* <div className="d-flex flex-row"> */}
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4 me-0 mt-3 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      {" "}
                      CLIENT{" "}
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {" "}
                      {getIndividualDispatchOrderDataMod?.clientName || ""}{" "}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {getIndividualDispatchOrderDataMod?.clientAddress
                        ?.street1 ||
                        getIndividualDispatchOrderDataMod?.clientAddress
                          ?.street2}
                      ,{getIndividualDispatchOrderDataMod?.clientAddress?.city}{" "}
                      ,{getIndividualDispatchOrderDataMod?.clientAddress?.state}
                      {
                        getIndividualDispatchOrderDataMod?.clientAddress
                          ?.country
                      }{" "}
                      ,{getIndividualDispatchOrderDataMod?.clientAddress?.zip}{" "}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4 me-0 mt-3 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      PROJECT
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {getIndividualDispatchOrderDataMod?.projectName || ""}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4 me-0 mt-3">
                    <div className="goodsin-received-date-text-style">
                      PROJECT MANAGER
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {projectManager?.firstName} {projectManager?.lastName}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {projectManager?.email}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {projectManager?.phoneNumber}
                    </div>
                  </div>
                  {/* </div> */}

                  {/* <div className="d-flex flex-row mt-2"> */}
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4 me-0 mt-3 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      CONTACT PERSON
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {getIndividualDispatchOrderDataMod?.contactName}
                    </div>
                    <div className="details-goodsin-address-text-style details-text-value-style text-start word-wrap-or-text-wrap">
                      {getIndividualDispatchOrderDataMod?.contactEmail || ""}
                    </div>
                    <div className="details-goodsin-address-text-style details-text-value-style text-start word-wrap-or-text-wrap">
                      {getIndividualDispatchOrderDataMod?.contactPhone || ""}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4 me-0 mt-3 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      RAISED BY
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {raisedBy?.firstName || ""} {raisedBy?.lastName || ""}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {" "}
                      {raisedBy?.email || ""}
                    </div>
                    <div className="details-goodsin-address-text-style  text-start word-wrap-or-text-wrap">
                      {" "}
                      {raisedBy?.phoneNumber || ""}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4 me-0 mt-3">
                    <div className="goodsin-received-date-text-style">
                      ACCEPTED BY
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {approvedBy?.firstName} {approvedBy?.lastName}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {approvedBy?.email}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {approvedBy?.phoneNumber}
                    </div>
                  </div>
                  {/* </div> */}

                  {/* <div className="d-flex flex-row mt-2"> */}
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4 me-0 mt-3 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      DELIVERY ADDRESS{" "}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      <div>
                        {address?.street1 || address?.street2}, {address?.city},
                        {address?.state} {address?.country},{address?.zip}
                      </div>
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4 me-0 mt-3 inbetn-space-for-high-level-details">
                    <div className="goodsin-received-date-text-style">
                      DEPOT
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {getIndividualDispatchOrderDataMod?.depotName}
                    </div>
                  </div>
                  <div className="col-12 col-sm-12 col-md-6 col-lg-4 me-0 mt-3">
                    <div className="goodsin-received-date-text-style">
                      DEPOT MANAGER
                    </div>
                    <div className="details-top-date-text-style word-wrap-or-text-wrap">
                      {depotManager?.firstName} {depotManager?.lastName}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {depotManager?.email}
                    </div>
                    <div className="details-goodsin-address-text-style text-start word-wrap-or-text-wrap">
                      {depotManager?.phoneNumber}
                    </div>
                  </div>
                  {/* </div> */}
                </div>
                <div className="row pt-1">
                  <div className="col-md-8 mt-1">
                    <div class="table-responsive">
                      <table class="table">
                        <tbody>
                          <tr>
                            {finalDeliveryStatus().map((d, key) => {
                              if (
                                deliveryStatus[key - 1]?.name ===
                                getIndividualDispatchOrderDataMod?.statusValue
                              ) {
                                statusflag = "black";
                              }
                              let eventDate = _.find(
                                getIndividualDispatchOrderDataMod?.deliveryOrderStatusEvents,
                                (d1) => d1.statusValue === d?.name
                              )?.eventDate;
                              if (!eventDate && d.name == "Review") {
                                eventDate = _.find(
                                  getIndividualDispatchOrderDataMod?.deliveryOrderStatusEvents,
                                  (d1) => d1.statusValue === "Pending"
                                )?.eventDate;
                              }
                              if (eventDate && d.name == "Pending" && getIndividualDispatchOrderDataMod?.statusValue == "Review") {
                                eventDate = "";
                              }
                              return (
                                <td className="p-1">
                                  <div className="d-flex justify-content-between">
                                    <span className=" text-uppercase dispatch-statues-style" style={{ color: statusflag }}>
                                      {d.status}
                                    </span>
                                    <span className="ms-3 me-3 d-flex align-items-center">
                                      <ArrowForwardOutlinedIcon fontSize={"12"} />
                                    </span>
                                  </div>
                                  <div>
                                    <span
                                      className=" text-uppercase dispatch-statues-date-style"
                                      style={{ fontSize: 12 }}
                                    >
                                      {eventDate ? convertIsoToLocalDateTime(`${eventDate}.00Z`, "DD-MMM-YYYY") : "--"}
                                      {/* {(!eventDate && d.status == "Review") && moment(_.find(getIndividualDispatchOrderDataMod?.deliveryOrderStatusEvents, (d1) => d1.statusValue === "Pending")?.eventDate).format("DD-MMM-YYYY")} */}
                                    </span>

                                  </div>
                                  <div
                                    className="dispatch-statues-time-style"
                                    style={{ fontSize: 12 }}
                                  >
                                    {/* {eventDate ? convertIsoToLocalDateTime(`${eventDate}.00Z`, "LT") : "--"} */}
                                    {eventDate ? convertIsoToLocalDateTime(`${eventDate}.00Z`, "HH:mm") : "--"}
                                  </div>
                                </td>
                              );
                            })}
                          </tr>
                        </tbody>
                      </table>
                    </div>
                  </div>

                  <div
                    className="col-md-4 pt-1"
                    style={{ borderLeft: "1px solid" }}
                  >
                    <div className="d-flex flex-row">
                      <div className="  d-flex flex-column ps-1 pe-1 me-2">
                        <div className="dispatch-statues-style text-center">
                          VEHICLES
                        </div>
                        <div className="dispatch-statues-date-style text-center mt-2">
                          {getIndividualDispatchOrderDataMod?.dispatches
                            ?.length || 0}
                        </div>
                      </div>
                      {getIndividualDispatchOrderDataMod?.type ==
                        "ClientCollection" ? (
                        ""
                      ) : (
                        <>
                          <div className="d-flex flex-column ps-1 pe-1">
                            <div className="dispatch-statues-style">ON-SITE</div>
                            <div className="dispatch-statues-date-style text-center mt-2">
                              {handleHoursAndMinutes(
                                getIndividualDispatchOrderDataMod?.dispatches ||
                                [],
                                "onSiteTime"
                              ) || "-- --"}
                            </div>
                          </div>
                        </>
                      )}
                    </div>
                  </div>
                </div>

                {/* <div
                  style={{
                    display: "flex",
                    paddingTop: 30,
                    justifyContent: "space-between",
                  }}
                >
                  <div className="req-text-style-for-dispatch-details">
                    REQUIREMENTS
                  </div>
                  <div className="req-text-style-for-dispatch-details">
                    DISPATCHED
                  </div>
                </div> */}
                <div
                  className="row"
                  style={{
                    paddingTop: 10,
                    paddingBottom: 20,
                    borderBottom: "1px solid #0146d9",
                    paddingLeft: 10,
                  }}
                >
                  <div className="table-responsive px-0">
                    <table
                      className="table goodsin-table table-borderless p-0"
                      style={{ width: "100%" }}
                    >
                      <thead className="goodsin-table-header">
                        <tr>
                          <td colspan="4"><span className="req-text-style-for-dispatch-details" style={{ fontSize: "14" }}>REQUIREMENTS</span></td>
                          <td><span className="req-text-style-for-dispatch-details" style={{ fontSize: "14" }}>DISPATCHED</span></td>
                        </tr>
                        <tr style={{ width: "100%" }}>
                          <th
                            className={`text-uppercase text-primary set-header-width-for-long-text`}
                            style={{ width: "25%" }}
                          >
                            <span className="items-table-header-count">
                              {deliveryItems?.length || 0}
                            </span>
                            <div className="items-table-text"> ITEMS</div>
                          </th>
                          <th
                            className={` text-uppercase text-primary set-header-width-for-long-text`}
                            style={{ width: "25%" }}
                          >
                            <span className="items-table-header-count">
                              {damageCount}
                            </span>
                            <div className="items-table-text"> DAMAGED</div>
                          </th>
                          <th
                            className={`text-uppercase text-primary set-header-width-for-medium-text`}
                            style={{ width: "38%" }}
                          >
                            <span className="items-table-text">DESCRIPTION</span>
                          </th>
                          <th
                            className={`text-uppercase text-primary set-header-width-for-long-text`}
                            style={{ width: "3%" }}
                          >
                            <span className="items-table-header-count">
                              {unitsCount}
                            </span>
                            <div className="items-table-text"> UNITS</div>
                          </th>
                          <th
                            className={`text-uppercase text-primary set-header-width-for-long-text`}
                            style={{ width: "3%" }}
                          >
                            <div
                              style={{ borderLeft: "1px solid", paddingLeft: 10 }}
                            >
                              <span className="items-table-header-count">
                                {unitsCountForDispatch}
                              </span>
                              <div className="items-table-text"> UNITS</div>
                            </div>
                          </th>
                        </tr>
                      </thead>
                      <tbody className="goods-table-body">
                        {/* {(dispatchDetailsData?.deliveryItems || []).map( */}
                        {_.orderBy(
                          dispatchDetailsData?.deliveryItems || [],
                          ["itemNumber"],
                          ["asc"]
                        ).map((itemdata, index) => {
                          let findDispatchData = _.filter(
                            allDispatchItem || [],
                            (d) => d.itemId === itemdata.itemId
                          );
                          let units = _.sumBy(
                            findDispatchData,
                            (d) => d.quantityDispatched
                          );
                          let flag = itemdata.quantity - units;
                          if (flag > 0 && !checkAllAvailableDataIsDispatched) {
                            setCheckAllAvailableDataIsDispatched(true);
                          }
                          return (
                            <tr
                              key={index}
                              className="goodsin-items-tr"
                              style={{ width: "100%" }}
                            >
                              <td style={{ width: "25%" }}>
                                {itemdata.itemNumber}
                              </td>
                              <td style={{ width: "25%" }}>{itemdata.condition}</td>
                              <td style={{ width: "38%" }}>
                                {itemdata.description}
                              </td>
                              <td style={{ width: "3%" }}>{itemdata.quantity}</td>
                              <td style={{ width: "3%", marginTop: 2 }}>
                                <div
                                  style={{
                                    borderLeft: "1px solid",
                                    paddingLeft: 10,
                                  }}
                                >
                                  {units ? units : "-"}
                                </div>
                              </td>
                            </tr>
                          );
                        })}
                      </tbody>
                    </table>
                  </div>
                </div>

                {Object.keys(ActiveData).length > 0 ? (
                  <>
                    <div className="d-flex flex-wrap main-class-for-tabs mb-4 mt-3">
                      {vehicalData.map((d, index) => {
                        return (
                          <React.Fragment key={index}>
                            <div
                              className={`vehicle-tab-names-style pe-2 ${ActiveIndex == 0 ? "remove-border-for-tab" : ""
                                } ${ActiveData?.tabName == `VEHICLE ${index + 1}`
                                  ? "color-change-for-tab"
                                  : ""
                                } `}
                              onClick={() => setActiveIndex(index)}
                            >
                              {d.tabName}
                            </div>
                          </React.Fragment>
                        );
                      })}
                    </div>

                    <div className="row">
                      <div className="col-md-3">
                        <TextField
                          className="depot-form-textfields-style textfield-color-class mt-3 mt-md-0"
                          value={ActiveData?.vrn}
                          id="standard-basic"
                          label="VRN"
                          variant="standard"
                        />
                      </div>
                      <div className="col-md-3">
                        <TextField
                          className="depot-form-textfields-style textfield-color-class mt-3 mt-md-0"
                          value={ActiveData?.vehicleModel}
                          id="standard-basic"
                          label="VEHICLE TYPE"
                          variant="standard"
                        />
                      </div>
                      <div className="col-md-3">
                        <TextField
                          className="depot-form-textfields-style textfield-color-class mt-3 mt-md-0 "
                          value={ActiveData?.driverName}
                          id="standard-basic"
                          label="DRIVER NAME"
                          variant="standard"
                        />
                      </div>
                      <div className="col-md-3">
                        <TextField
                          className="depot-form-textfields-style textfield-color-class mt-3 mt-md-0"
                          id="standard-basic"
                          value={ActiveData?.driverContact}
                          label="CONTACT NUMBER"
                          variant="standard"
                        />
                      </div>
                      <div className="row mt-3">
                        <div className="col-md-3" style={{ position: "relative" }}>
                          <TextField
                            className="depot-form-textfields-style textfield-color-class"
                            value={ActiveData?.internalSpaceReleased || 0}
                            id="standard-basic"
                            label="INTERNAL"
                            variant="standard"
                          />
                          <div style={{ position: "absolute", right: 10, top: 15, }}>M<sup>2</sup></div>
                        </div>
                        <div className="col-md-3" style={{ position: "relative" }}>
                          <TextField
                            className="depot-form-textfields-style textfield-color-class"
                            value={ActiveData?.externalSpaceReleased || 0}
                            id="standard-basic"
                            label="EXTERNAL"
                            variant="standard"
                          />
                          <div style={{ position: "absolute", right: 10, top: 15, }}>M<sup>2</sup></div>
                        </div>
                      </div>
                    </div>

                    <div className="table-responsive mt-3">
                      <table className="table goodsin-table table-borderless p-0">
                        <thead>
                          <tr>
                            <th>
                              <span className="items-table-header-count">
                                {ActiveData?.items?.length || 0}
                              </span>
                              <span className="items-table-text"> ITEMS</span>
                            </th>
                            <th>
                              <span className="items-table-header-count">
                                {damageCountForDispatch}
                              </span>
                              <span className="items-table-text"> DAMAGED</span>
                            </th>
                            <th>DESCRIPTION</th>
                            <th>
                              <span className="items-table-header-count">
                                {unitsCountForDispatch}
                              </span>
                              <span className="items-table-text"> UNITS</span>
                            </th>
                          </tr>
                        </thead>
                        <tbody className="goods-table-body">
                          {_.orderBy(
                            ActiveData?.items || [],
                            ["itemNumber"],
                            ["asc"]
                          ).map((item, index) => {
                            return (
                              <React.Fragment key={index}>
                                <tr key={index} className="goodsin-items-tr">
                                  <td>{item.itemNumber}</td>
                                  <td>{item.condition}</td>
                                  <td>{item.description}</td>
                                  <td>{item.quantityDispatched}</td>

                                </tr>
                              </React.Fragment>
                            );
                          })}
                        </tbody>
                      </table>
                    </div>

                    {uploadedPicture?.length > 0 && (
                      <>
                        <div className="row pt-3 pb-0 mb-2 mt-2 ps-1">
                          <InputLabel className="goodsin-form-section-header-name">
                            {" "}
                            {uploadedPicture?.length} PHOTOS
                          </InputLabel>
                        </div>

                        <div className="row">
                          {uploadedPicture?.map((d, index) => {
                            return (
                              <React.Fragment key={index}>
                                <div className="mb-2 pt-2 images-shown-style">
                                  <Box
                                    className="image-box-style"
                                    component="img"
                                    alt="The house from the offer."
                                    src={d.url}
                                    style={{ cursor: "pointer" }}
                                    onClick={() => openFullScreen(d.url)}
                                  ></Box>
                                  {d.isDamaged ? (
                                    <div className="dmg-icon-shown-on-image-style">
                                      <img
                                        height={33}
                                        width={33}
                                        src={IconError}
                                        alt="dmg"
                                      />
                                    </div>
                                  ) : null}
                                </div>
                              </React.Fragment>
                            );
                          })}
                        </div>
                      </>
                    )}

                    {isFullScreen && (
                      <div
                        className="full-screen-overlay"
                        onClick={closeFullScreen}
                      >
                        <div className="full-screen-image">
                          <img src={selectedImage} alt="Full-screen Image" />
                        </div>
                      </div>
                    )}

                    {uploadeddocument?.length > 0 && (
                      <>
                        <div className="row pt-3 pb-0 mb-2 mt-2 ps-1">
                          <InputLabel className="goodsin-form-section-header-name">
                            {" "}
                            {uploadeddocument?.length} DOCUMENTS
                          </InputLabel>
                        </div>

                        {uploadeddocument.map((d, index) => {
                          return (
                            <div key={index} className="row mt-2">
                              <a href={d.url} target="_blank">
                                <div className="col-md-12">
                                  {d?.fileName || "dsd"}
                                </div>
                              </a>
                            </div>
                          );
                        })}
                      </>
                    )}

                    <div className="row justify-content-between mt-4">
                      <div className="col-md-4 d-flex flex-column">
                        <span className="details-departure-style">DEPARTURE</span>

                        <span className="text-uppercase details-departure-status-style text-uppercase">
                          {ActiveData?.statusValue == "Pending"
                            ? ActiveData?.statusValue
                            : ActiveData.departureDate1
                              ? convertIsoToLocalDateTime(`${ActiveData.departureDate1}.000Z`, "DD-MMM-YYYY HH:mm")
                              : "-- --"}
                        </span>
                      </div>
                      {ActiveData?.statusValue === "Delivered" &&
                        getIndividualDispatchOrderDataMod?.type == "Delivery" ? (
                        <>
                          <div className="col-md-4 d-flex flex-column">
                            <span className="details-departure-style text-uppercase">
                              DELIVERED
                            </span>
                            <span className="text-uppercase details-departure-status-style text-uppercase">
                              {ActiveData?.deliveredDate
                                ? convertIsoToLocalDateTime(`${ActiveData.deliveredDate}.00Z`, "DD-MMM-YYYY HH:mm")

                                : "-- --"}
                            </span>
                          </div>

                          <div className="col-md-4 d-flex flex-column">
                            <span className="details-departure-style">
                              ON-SITE (Hrs)
                            </span>
                            <span className="text-uppercase details-departure-status-style">
                              {ActiveData?.onSiteTime
                                ? (ActiveData?.onSiteTime).slice(0, 5)
                                : ""}
                            </span>
                          </div>
                        </>
                      ) : (
                        ""
                      )}
                    </div>

                    {ActiveData?.statusValue == "InTransit" && (
                      <div className="mt-4 mb-3 add-border-details">
                        <span></span>
                      </div>
                    )}

                    {ActiveData?.statusValue == "Delivered" && (
                      getIndividualDispatchOrderDataMod?.type == "Delivery" ? (
                        <div className="row mt-4">
                          <div className="col-md-4 d-flex flex-column">
                            <span className="details-departure-style">
                              RECEIVER
                            </span>
                            <span className="details-departure-status-style">
                              {ActiveData?.receiverName || ""}
                            </span>
                          </div>
                          <div className="col-md-4 d-flex flex-column">
                            <span className="details-departure-style">
                              POSITION
                            </span>
                            <span className="details-departure-status-style">
                              {ActiveData?.receiverPosition || ""}
                            </span>
                          </div>
                          <div className="col-md-4 d-flex flex-column">
                            <span className="details-departure-style">PHONE</span>
                            <span className="details-departure-status-style">
                              {ActiveData?.receiverPhone || ""}
                            </span>
                          </div>
                        </div>
                      ) : ""
                    )}
                  </>
                ) : (
                  ""
                )}

                {["Delivered", "InTransit", "Dispatched"].includes(
                  getIndividualDispatchOrderDataMod?.status
                ) ? (
                  ""
                ) : (
                  <div
                    style={{
                      display: "flex",
                      justifyContent: "space-between",
                      marginTop: 20,
                    }}
                  >
                    <Button
                      disabled={
                        getIndividualDispatchOrderDataMod?.status == "Review" ||
                          getIndividualDispatchOrderDataMod?.status == "Pending"
                          ? false
                          : true
                      }
                      className={`cancel-order-dispatchedit-btn-style ${getIndividualDispatchOrderDataMod?.status == "Review" ||
                        getIndividualDispatchOrderDataMod?.status == "Pending"
                        ? ""
                        : "add-cancel-order-bg-color"
                        }`}
                      onClick={() => _openCancelModel(!openCancelModel)}
                      variant="outlined"
                    >
                      <img src={IconCancel} height={15} width={15}></img>
                      <span className="ms-2">CANCEL ORDER</span>
                    </Button>
                    {getIndividualDispatchOrderDataMod?.status == "Review" ||
                      getIndividualDispatchOrderDataMod?.status == "Pending" ? (
                      <Button
                        // {AS PER CR:ENABLE EDIT BTN ON BOTH PENDING AND REVIEW STATE}                  
                        // disabled={
                        //   getIndividualDispatchOrderDataMod?.status == "Review"
                        //     ? false
                        //     : true
                        // }
                        // className={`ms-2 edit-dispatch-button-style ${getIndividualDispatchOrderDataMod?.status == "Review"
                        //   ? ""
                        //   : "add-cancel-order-bg-color"
                        //   }`}
                        className="ms-2 edit-dispatch-button-style "
                        variant="outlined"
                        onClick={async () => {
                          setOpen(!open)
                          await getDispatchOrderInDataFunc();
                        }
                        }
                      >
                        <img
                          src={require("../../assets/images/edit.png")}
                          height={15}
                          width={15}
                        />
                        <span className="ms-2">EDIT RECORD</span>
                      </Button>
                    ) : (
                      ""
                    )}
                    {/* CR: REMOVE ACESS OF PM TO DELETE ORDER.  */}
                    {/* <Button
                      className={`cancel-order-dispatchedit-btn-style ${getIndividualDispatchOrderDataMod?.statusValue ==
                        "Cancelled"
                        ? ""
                        : "add-cancel-order-bg-color"
                        }`}
                      variant="outlined"
                      onClick={() => _deleteRecordModal(!deleteRecordModal)}
                      disabled={
                        getIndividualDispatchOrderDataMod?.statusValue ==
                          "Cancelled"
                          ? false
                          : true
                      }
                    >
                      <DeleteIcon
                        className="remove-item-icon-color"
                        style={{
                          cursor: "pointer",
                          color:
                            getIndividualDispatchOrderDataMod?.statusValue ==
                              "Cancelled"
                              ? "red"
                              : "gray",
                          fontSize: 20,
                        }}
                      />
                      DELETE RECORD
                    </Button> */}
                  </div>
                )}

                <div style={{ height: 100 }}></div>
              </div>
            </div>
          </div>

          <div className="col-12 col-lg-2 mt-2 mt-lg">
            <div className="goodsin-details-remark-section-main-div-style ps-0 w-100">
              {showRemark ? (
                <div className="pb-3 add-border-between-remarks-goodsin">
                  <div className="pt-2 ms-2 remark-add-div-goodsin-details">
                    <form
                      onSubmit={handleSubmit(handleSubmitRemark)}
                    >
                      <TextField className="d-flex"
                        id="outlined-basic"
                        label="Something is being typed here"
                        variant="outlined"
                        multiline
                        {...register("comments")}
                      />
                      {errors.comments ? (
                        <div className=" mt-1 text-danger error-remark-style">
                          {errors.comments?.message}
                        </div>
                      ) : null}
                      <div className="d-flex pt-2 justify-content-end align-items-center">
                        <div
                          className="cursor-style"
                          onClick={handleCancelRemark}
                        >
                          Cancel
                        </div>
                        <div className="ms-2">
                          <Button
                            className="remark-button-bg"
                            type="submit"
                            variant="contained"
                            style={{ background: "#BEBFC2" }}
                          >
                            save
                          </Button>
                        </div>
                      </div>
                    </form>
                  </div>
                </div>
              ) : (
                <div className="leave-remark-main-div">
                  <div
                    onClick={() => {
                      setShowRemark(!showRemark);
                    }}
                    className="leave-remark-text-style d-flex align-items-center ps-1 ms-3"
                  >
                    Leave remark...
                  </div>
                </div>
              )}
              {remarksData?.length > 0 &&
                remarksData?.map((d, index) => {
                  return (
                    <div
                      key={index}
                      className="add-border-between-remarks-goodsin"
                    >
                      <div className="p-3 padding-remark-adjust-class">
                        <div className="d-flex">
                          <img
                            style={{ borderRadius: "50%" }}
                            src={d?.profileUrl || "https://img.freepik.com/free-icon/user_318-563642.jpg"}
                            onError={imgError}
                            className="remark-avatar-style"
                          ></img>
                          <div className="ms-2">
                            <div className="remarkperson--name-shown-style">
                              {d?.firstName || ""} {d?.lastName || ""}{" "}
                            </div>
                            <div className="remarkperson--name-shown-style">
                              {moment(d?.timeStamp || "").format("LT")},
                              {moment(d?.timeStamp || "").format("DD MMM YYYY")}
                            </div>
                          </div>
                        </div>
                        <div className="pt-1 remark-comment-style">
                          {d.comments}
                        </div>
                      </div>
                    </div>
                  );
                })}
              <div style={{ height: 100 }}></div>
            </div>
          </div>

          {/* <div className="extra-added-pmdiv-for-goodsindetails"></div> */}
        </div>
      </div>

      <Modal
        open={open}
        onClose={handleClose}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <div className="depot-form-header-style">EDIT DISPATCH ORDER</div>
          <DispatchForm
            editData={getIndividualDispatchOrderDataMod}
            handleClose={handleClose}
          />
        </Box>
      </Modal>

      <Modal
        open={openCancelModel}
        onClose={() => _openCancelModel(!openCancelModel)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box className="cancelModalStyle">
          <div>
            <div className="depot-form-header-style">
              <span className="allocate-mgnr-header-color me-2">
                CANCEL DELIVERY ORDER{" "}
              </span>
              <span className="allocate-mgnr-subheader-color">
                {getIndividualDispatchOrderDataMod?.orderNo || ""}
              </span>
            </div>
            <div className="innerWrap">
              <div className="d-flex flex-column" style={{ marginTop: 50 }}>
                <span className="removeDepotManager-text-removed common-text-for-removeDepotManager mb-2">
                  You are cancelling   {" "}
                </span>
                <span className="common-text-for-removeDeliveryOrder mb-2">
                  Delivery Order {" "}
                  <strong>
                    {getIndividualDispatchOrderDataMod?.orderNo || ""}
                  </strong>{" "}
                </span>
                <span className="long-text-style-unlist-depot mb-1">
                  This order will be marked 'CANCELLED'.{" "}
                </span>
                <span className="long-text-style-unlist-depot mb-1">
                  This order will not appear on Dashboards.
                </span>
                <span className="long-text-style-unlist-depot mb-1">
                  This order cannot be edited or updated any further.{" "}
                </span>
              </div>
              <div className="d-flex flex-column mt-5">
                <span className="mb-3 confirm-msg-for-removeDepotManager">
                  Are you sure you want to proceed?
                </span>
                <div className="d-flex flex-row">
                  <button
                    className="me-5 p-2 back-action-button-color-for-depotmanagers removeManagerButtons"
                    onClick={() => _openCancelModel(!openCancelModel)}
                  >
                    <img
                      className="me-2"
                      src={IconLeftArrow}
                      alt="left"
                      width={15}
                      height={15}
                    />
                    NO, GO BACK
                  </button>
                  <button
                    className="removeManagerButtons p-2 remove--action-button-color-for-depotmanagers"
                    onClick={handleCancelOrderClick}
                  >
                    <img
                      className="me-2"
                      width={15}
                      height={15}
                      src={IconCancel}
                      alt="cancel"
                    />
                    <span>YES, CANCEL ORDER</span>
                  </button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>

      <Modal
        open={deleteRecordModal}
        onClose={() => _deleteRecordModal(!deleteRecordModal)}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box sx={modalStyle}>
          <div>
            <div className="depot-form-header-style">
              <span className="allocate-mgnr-header-color text-uppercase me-2">
                DELETE DELIVERY ORDER
              </span>
              <span className="allocate-mgnr-subheader-color">
                {dispatchDetailsData?.orderNo}
              </span>
            </div>
            <div style={{ paddingLeft: 100, paddingRight: 100 }}>
              <div className="d-flex flex-column" style={{ marginTop: 100 }}>
                <span className="removeDepotManager-text-removed common-text-for-removeDepotManager mb-2">
                  You are deleting Delivery order.
                </span>
                <span className="long-text-style-unlist-depot mb-1">
                  This record will not appear on dispatch list.
                </span>
              </div>
              <div className="d-flex flex-column mt-5">
                <span className="mb-3 confirm-msg-for-removeDepotManager">
                  Are you sure you want to proceed?
                </span>
                <div className="d-flex flex-row">
                  <Button
                    variant="outlined"
                    className="btn-bootstrap-submit-style"
                    startIcon={
                      <img
                        src={IconLeftArrow}
                        width={15}
                        height={15}
                        alt="new"
                      ></img>
                    }
                    onClick={() => _deleteRecordModal(!deleteRecordModal)}
                  >
                    No, Go Back
                  </Button>
                  <Button
                    variant="outlined"
                    className="btn-bootstrap-submit-style ms-3"
                    style={{ color: "red", borderColor: "red" }}
                    onClick={handleDeleteRecordClick}
                    startIcon={
                      <img
                        src={IconCancel}
                        width={15}
                        height={15}
                        alt="new"
                      ></img>
                    }
                  >
                    YES, DELETE RECORD
                  </Button>
                </div>
              </div>
            </div>
          </div>
        </Box>
      </Modal>
    </>
  );
};
